import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function UniqueVisitorsPage() {
    return (
        <OnboardingBody title='Unique visitors' statusText='Engagement report'>
            <p>
                After embedding the chat widget, we’ll track all first-time visitors to your site.
                Each visitor is counted just once, no matter how many pages they view.
            </p>
            <p>
                <em>Example: If someone visits 5 pages, they’re only counted once.</em>
            </p>
        </OnboardingBody>
    );
}
